(function ($, Drupal) {

  // Background image swap function via data attribute
  Drupal.behaviors.initBgImg = {
    attach: function (context, settings) {

      $('[data-url]', context).once('initBgImg').each(function (index, item) {

        const $el = $(this),
              $img = $el.data('url'),
              $window = $(window);

        var $imgDesktop = $img,
            $imgTablet = $img;

        // Check if Desktop or Tablet variations are available
        if ($el.data('url_desktop')) {
          $imgDesktop = $el.data('url_desktop');
        }

        if ($el.data('url_tablet')) {
          $imgTablet = $el.data('url_tablet');
        } else if ($el.data('url_desktop')) {
          $imgTablet = $el.data('url_desktop');
        }

        function setImage($val) {
          switch ($val) {
            case 0:
              $el.css('background-image', 'url("' + $img + '")');
              break;
            case 0.5:
              $el.css('background-image', 'url("' + $imgTablet + '")');
              break;
            case 1:
              $el.css('background-image', 'url("' + $imgDesktop + '")');
              break;
          }
        }

        const trigger = throttle((e) => {
          setImage(parseFloat(resolutionCheck()));
        }, 500);

        trigger();
        $window.resize(trigger);

      });

    }
  };

})(jQuery, Drupal);
